module.exports = __webpack_public_path__ + "static/media/clydeEdnaWedding.26011724.png";